import React, { useState, useEffect } from 'react'
import { fetchXceedEvents } from '../utils/api'

const EventBanner = () => {
  const [nextEvent, setNextEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isClosed, setIsClosed] = useState(false);

  // Function to format date
  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  useEffect(() => {
    const fetchNextEvent = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch events from our backend proxy; use fallback data if backend is unavailable
        const eventsData = await fetchXceedEvents();

        // Get the next upcoming event
        const now = Math.floor(Date.now() / 1000); // Current time in seconds
        const upcomingEvents = eventsData.filter(event => event.startingTime > now)
          .sort((a, b) => a.startingTime - b.startingTime);

        if (upcomingEvents.length > 0) {
          setNextEvent(upcomingEvents[0]); // Get the first upcoming event
        } else {
          // No upcoming events - this is not an error
          console.log('No upcoming events found');
          setNextEvent(null);
        }

        setLoading(false);
      } catch (err) {
        console.error('Error fetching events:', err);
        setError('Unable to fetch events');
        setNextEvent(null);
        setLoading(false);
      }
    };

    fetchNextEvent();
  }, []);

  // Don't render if closed
  useEffect(() => {
    if (isClosed) {
      document.body.setAttribute('data-banner-visible', 'false');
    } else {
      document.body.setAttribute('data-banner-visible', 'true');
    }
  }, [isClosed]);

  if (isClosed) {
    return null;
  }

  if (loading) {
    return (
      <div className="event-banner">
        <div className="container" style={{ position: 'relative' }}>
          <p>
            <span>Loading next event...</span>
          </p>
          <button
            onClick={() => setIsClosed(true)}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'transparent',
              border: 'none',
              color: '#fff',
              fontSize: '1.2rem',
              cursor: 'pointer',
              padding: '5px',
              lineHeight: 1
            }}
            aria-label="Close banner"
          >
            ✕
          </button>
        </div>
      </div>
    );
  }

  // If no upcoming events, show a message
  if (!nextEvent) {
    return (
      <div className="event-banner">
        <div className="container" style={{ position: 'relative' }}>
          <p>
            <span>🎵 No upcoming events at the moment. Check back soon! 🎵</span>
          </p>
          <button
            onClick={() => setIsClosed(true)}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'transparent',
              border: 'none',
              color: '#fff',
              fontSize: '1.2rem',
              cursor: 'pointer',
              padding: '5px',
              lineHeight: 1
            }}
            aria-label="Close banner"
          >
            ✕
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="event-banner">
      <div className="container" style={{ position: 'relative' }}>
        <p>
          <span>🔥 NEXT SHOW: {nextEvent.name} - {formatDate(nextEvent.startingTime)} - {nextEvent.venue.city.name}, {nextEvent.venue.city.country.name} 🔥</span>
          <a
            href={`https://xceed.me/en/${nextEvent.venue.city.slug}/event/${nextEvent.slug}--${nextEvent.legacyId}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#fff',
              backgroundColor: '#333',
              padding: '5px 10px',
              borderRadius: '25px',
              textDecoration: 'none',
              fontWeight: 'bold',
              fontSize: '0.9rem'
            }}
          >
            GET TICKETS
          </a>
        </p>
        <button
          onClick={() => setIsClosed(true)}
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'transparent',
            border: 'none',
            color: '#fff',
            fontSize: '1.2rem',
            cursor: 'pointer',
            padding: '5px',
            lineHeight: 1
          }}
          aria-label="Close banner"
        >
          ✕
        </button>
      </div>
    </div>
  )
}

export default EventBanner
